import { ConstraintTypeEnum, IConstraint } from '@se/constraint';

/**
 * filtraggio regole disattivate basato su regola di tipo Disabler. (task 75339-75338)
 * @param constraints
 */
export const filterConstraintsByDisabler = (constraints: IConstraint[]): IConstraint[] => {
    const ids = new Set(constraints
        .filter(constraint => constraint.constraintType === ConstraintTypeEnum.Disabler)
        .map(constraint => [constraint.id, constraint.constraintIdRef]).flat());
    if (!ids.size) return constraints;
    return constraints.filter(constraint => !ids.has(constraint.id));
};
